import { useQuery } from '@tanstack/react-query';

import { MonitoringHealthComponent } from 'src/features/monitoring/types';
import { SYSTEM_COMPONENT, SYSTEM_COMPONENT_STATUS } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/monitoring/health/components/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    status?: SYSTEM_COMPONENT_STATUS | SYSTEM_COMPONENT_STATUS[];
    site?: string;
    zone?: string;
    gateway?: string;
    pay_station?: string;
    component?: SYSTEM_COMPONENT | SYSTEM_COMPONENT[];
    component_type?: string;
    has_active_issues?: boolean;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<MonitoringHealthComponent>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        // WS HEALTH_STATUS_UPDATED invalidates this query when health changes,
        // so the list can stay cached between renders.
        staleTime: 5 * 60 * 1000,
        ...config,
    });

export { RESOURCE as LIST_MONITORING_HEALTH_COMPONENTS_RESOURCE, useQueryHook as useListMonitoringHealthComponents };
